export const extractNumberFromText = (text) => {
  const matches = text.match(/\d+\+/g) || text.match(/\d+/g)
  return matches ? matches : []
}
